import * as React from 'react';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import client from '@api/client';
import { useLocalActor } from '@api/useLocalActor';
import { RouteNames } from '@constants/RouteNames';

const UFFICIOTTO_INVITE_LINK =
  'https://popspace.sqrt64.it/brainstorm-d3tj4k42e9q01cxxdiy07gwz?invite=UpTxc-5ZmY2-10BC8-ObCkr-0CDNp-sPUXX-S6f2t-xFdps';

const useStyles = makeStyles((theme) => ({
  loggedInAsText: {
    marginBottom: theme.spacing(2),
  },
  ufficiottoButton: {
    marginTop: theme.spacing(3),
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
  },
}));

export interface ILoggedInAsProps {}

/**
 * Shows who's currently logged in plus a logout action.
 * Renders nothing if there's no active session.
 */
export const LoggedInAs: React.FC<ILoggedInAsProps> = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const actor = useLocalActor();
  const classes = useStyles();

  if (!actor) {
    return null;
  }

  const handleLogout = async () => {
    await client.logout();
    history.push(RouteNames.SIGN_IN);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
      <Typography variant="body2" className={classes.loggedInAsText}>
        {t('header.loggedInAs', { name: actor.displayName || actor.email })}
        {actor.admin ? ` (${t('header.adminBadge')})` : ''}
      </Typography>
      <Button size="small" onClick={handleLogout}>
        {t('header.logout')}
      </Button>
      <Button
        size="small"
        className={classes.ufficiottoButton}
        href={UFFICIOTTO_INVITE_LINK}
        target="_blank"
        rel="noopener noreferrer"
      >
        Ufficiotto
      </Button>
    </Box>
  );
};
